module.exports = __webpack_public_path__ + "static/media/logo-vrf.b56f34f1.png";